

































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericPMSTableMenu from "@/components/generic-pms-table/GenericPMSTableMenu.vue";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { Notification } from "@/store/modules/notifications";
import NoData from "@/components/misc/NoData.vue";
import { NotificationTemplateViewModel } from "./types";
import * as _ from "lodash";
import { Action, Getter } from "vuex-class";
import { MessageSourceType } from "@/shared/models/messageSourceType";
import { NotificationTemplateRecipient } from "@/shared/models/notificationTemplateRecipient";
import { LanguageView } from "@/shared/models/languages";

@Component({
  components: {
    GenericPMSTableMenu,
    SortableHeadersTable,
    NoData,
  },
})
export default class NotificationTemplatesTable extends Vue {
  settingsOpen = false;

  @Action("codebooks/refreshMessageSourceTypes") refreshSourceTypes?: () => Promise<void>;
  @Getter("codebooks/messageSourceTypes") sourceTypes?: MessageSourceType[];

  @Action("codebooks/refreshNotificationTemplateRecipients") refreshNotificationTemplateRecipients?: () => Promise<void>;
  @Getter("codebooks/notificationTemplateRecipients") recipients?: NotificationTemplateRecipient[];

  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];

  isDraft = [{status: true, name: "NotificationSchedule.Active"},{status: false, name:"NotificationSchedule.Draft"}]

  async created(){
    const promises = [];

    if ((this.sourceTypes?.length ?? 0) === 0 && this.refreshSourceTypes) {
      promises.push(this.refreshSourceTypes());
    }
    if ((this.recipients?.length ?? 0) === 0 && this.refreshNotificationTemplateRecipients) {
      promises.push(this.refreshNotificationTemplateRecipients());
    }
    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      promises.push(this.refreshLanguages());
    }

    await Promise.all(promises);
  }

  headers: SortableTableHeader[] = [
    {
      text: "Name",
      value: "name",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "NotificationTemplate.Status",
      value: "isDraft",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Message.SourceType",
      value: "sourceTypes",
      active: true,
      default: false,
      class: "resize-header",
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Language",
      value: "languages",
      active: true,
      default: false,
      sortable: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "NotificationTemplate.Recipients",
      value: "recipients",
      active: true,
      default: false,
      sortable: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
    },
  ];

  filters = {
    name: "",
    isDraft: undefined as boolean | undefined,
    sourceTypeId: null as number | null,
    cultureCode: "",
    recipientId: null as number | null
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  get translatedActiveHeaders() {
    return this.headers
      .filter((x) => x.active)
      .map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["name"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<NotificationTemplateViewModel> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<ListModel<NotificationTemplateViewModel>> {
    this.loading = true;
    return this.axios
      .get<ListModel<NotificationTemplateViewModel>>("/notificationTemplates", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
    };
  }

  getSourceTypeNames(items: number[]){
    const list = this.sourceTypes?.filter(x => items.includes(x.id)).map(y => y.name)
    return list?.join(", ");
  }

  getLanguageName(item: string){
    const language = this.languages?.find(x => x.languageCode == item);
    if (language)
    return this.$t(language.textResourceKey);
  }

  getRecipientNames(items: number[]){
    const list = this.recipients?.filter(x => items.includes(x.id)).map(y => this.$t(y.textResourceKey));
    return list?.join(", ")
  }

  addTemplate() {
    this.$router.push({ path: "/settings/notification-templates/new" });
  }

  editTemplate(id: number) {
    this.$router.push({ path: `/settings/notification-templates/${id}` });
  }
  rowDoubleClick(
    e: MouseEvent,
    { item }: { item: NotificationTemplateViewModel }
  ) {
    this.editTemplate(item.id);
  }

  copyTemplate(id: number) {
    this.$router.push({
      path: "/settings/notification-templates/new?copy=" + id,
    });
  }

  deleteItem(item: NotificationTemplateViewModel) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${item?.name}'`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deleteItemConfirm({ id }: { id: number }) {
    Vue.axios
      .delete(`/notificationTemplates/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("NotificationTemplate.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.load();
      });
  }
}
